
















































import Vue from 'vue';
import MStoreForm from '@/components/shared/MStoreForm.vue';
import MStoreFormInput from '@/components/shared/MStoreFormInput.vue';
import MStoreFormTextarea from '@/components/shared/MStoreFormTextarea.vue';
import MStoreModal from '@/components/shared/MStoreModal.vue';
import { ValueType } from '@/types/enums/ValueType';
import { DocumentEmailService } from '@/services/DocumentEmailService';
import Toast from '@/classes/SnotifyConfiguration';
import { EmailConstants } from '@/types/constants/EmailConstants';
import { mapActions, mapGetters } from 'vuex';
import { confirmationHelper } from '@/mixins/confirmationHelper';
import { EventBus } from '@/classes/EventBus';
import { EVENT_BUS } from '@/types';

export default Vue.extend({
  name: 'DocumentEmailModal',
  mixins: [confirmationHelper],
  props: {
    modalId: {
      type: String,
      default: 'email-document-modal-id'
    },
    document: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      valueType: ValueType,
      emailData: {
        to: '',
        subject: '',
        body: ''
      },
      isSendingEmail: false
    };
  },
  computed: {
    ...mapGetters('applicationDirtyStore', ['isApplicationDirtyOnModal'])
  },
  methods: {
    ...mapActions('applicationDirtyStore', ['setApplicationDirtyOnModal']),
    async emailDocument(this: any) {
      this.isSendingEmail = true;
      const model = {
        ...this.emailData,
        cabinetId: this.document.cabinetId,
        documentId: this.document.id
      };
      try {
        await DocumentEmailService.emailDocumentAsync(model);
        Toast.showSuccess('The email was sent.');
        this.resetForm();
        this.hideModal();
        EventBus.$emit(EVENT_BUS.DOCUMENT_HISTORY_LOG_UPDATED, true);
      } finally {
        this.isSendingEmail = false;
      }
    },
    resetForm() {
      this.emailData.to = '';
      this.emailData.subject = '';
      this.emailData.body = '';
      this.setApplicationDirtyOnModal(false);
    },
    async hideModal(this: any) {
      let proceed = true;
      if (this.isApplicationDirtyOnModal) {
        // tslint:disable-next-line:quotemark
        proceed = !(await this.hasUnsavedChangesToKeepAsync(this.$bvModal, true, "You haven't sent this email."));
      }
      if (proceed) {
        this.resetForm();
        this.$bvModal.hide(this.modalId);
      }
    }
  },
  created(this: any) {
    this.EMAIL_CONSTANTS = EmailConstants;
  },
  components: {
    MStoreForm,
    MStoreFormInput,
    MStoreFormTextarea,
    MStoreModal
  }
});
